import React,{useContext, useState} from "react";
import { Table, Modal, Tag} from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import moment from "moment";
import { useListarSolicitudesAusencia, usePaginacion } from "../../hooks";
import { EstadoSolicitudAusencia } from "enums/EstadoSolicitudAusencia";
import MenuAcciones from "./MenuAcciones";
import {ModalSeguimiento} from "../ModalSeguimiento";
import {ModalAdjuntarAltaMedica} from "../ModalAdjuntarAltaMedica";
import {ModalCancelarSolicitud} from "../ModalCancelarSolicitud";
import { SecurityContext } from "context/SecurityContextProvider";
const ListaConsultaSolicitudes = () => {
  //const { solicitudesAusencia } = useListarSolicitudesAusencia("TODOS");
  const { totalRegistros, paginaActual, tamanioPaginado, onCambiarPaginacion, solicitudesAusencia } = usePaginacion();
  const { getUsuarioAutenticado } = useContext(SecurityContext);
  const isMaccaferriDePeru = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20418710757" ? true : false;
	const isMaccaferriConstruction = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20521749378" ? true : false;
  const isAceros = getUsuarioAutenticado().empresaSeleccionada?.ruc==="20538379302"	? true	: false;
  const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
  const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
  const [visible, setVisible] = useState(false);
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);
  const isGlore =
          getUsuarioAutenticado().empresaSeleccionada?.ruc === "20555936045"
            ? true
            : false;
            
  const columnas = [
    {
      title: "Colaborador",
      dataIndex: ["colaborador", "nombreCompleto"],
      width: "20%",
      align: "center",
    },
    {
      title: (isSDF || isSDFEnergia) ? "Tipo Movimiento":"Tipo Ausencia",
      dataIndex: ["tipo", "descripcion"],
      width: "10%",
      align: "center",
    },
    ...((isSDF ||isSDFEnergia)
    ? [
        {
          title: "Estado",
          align: "center",
          render: (text, fila) => {
            const eliminadoPorAdmin = fila.estado === "RECHAZADO" && fila.informacionAdicional?.eliminadoPorAdmin;
            const color = eliminadoPorAdmin
              ? "purple"
              : fila.estado === "APROBADO"
              ? "green"
              : fila.estado === "PENDIENTE"
              ? "gold"
              : fila.estado === "RECHAZADO"
              ? "red"
              : "magenta";

            return (
              <Tag
                color={color}
                style={{ cursor: "pointer" }}
                onClick={() => abrirDetalle(fila)}
              >
                {eliminadoPorAdmin ? "ELIMINADO (ADMIN)" : fila.estado}
              </Tag>
            );
          },
        },
      ]
    :[
    {
      title: "Otros cargos",
      width: "20%",
      align: "center",
      render: (text, fila) => {
        return(
          <React.Fragment>
            {fila.responsableOtrosCargos?.nombreCompleto}
            <br/>
            {fila.responsableOtrosCargos?.fechaAprobacion!==undefined && fila.responsableOtrosCargos?.fechaAprobacion!==null ? "Fecha Aprobación: "+ moment(fila.responsableOtrosCargos?.fechaAprobacion).format("DD/MM/YYYY"):
             fila.responsableOtrosCargos?.fechaRechazo!==undefined && fila.responsableOtrosCargos?.fechaRechazo!==null && "Fecha Rechazo: "+ moment(fila.responsableOtrosCargos?.fechaRechazo).format("DD/MM/YYYY")
            }
            <br />
            {
              fila.responsableOtrosCargos?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado=== EstadoSolicitudAusencia.PENDIENTE ?(
                <Tag color="warning">{fila.responsableOtrosCargos.estadoAprobacion}</Tag>
              ): fila.responsableOtrosCargos?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado=== "CANCELADO" ?(  
                <Tag color="purple">CANCELADO POR COLABORADOR</Tag>
              ): fila.responsableOtrosCargos?.estadoAprobacion === EstadoSolicitudAusencia.APROBADO ?(
                <Tag color="success">{fila.responsableOtrosCargos.estadoAprobacion}</Tag>
              ): fila?.admin && fila?.estado==="CANCELADO" ?(
                <Tag color="purple">{fila.estado}</Tag>                
              ):(
                <Tag color="error">{fila.responsableOtrosCargos?.estadoAprobacion}</Tag>
              )
            }         

            {/* {fila?.admin && fila?.estado=="APROBADO" &&(
              <Tag color="blue">{fila.estado}</Tag>
            )} */}
            {/* {fila?.admin && fila?.estado=="CANCELADO" &&(
              <Tag color="purple">{fila.estado}</Tag>
            )}              */}
          </React.Fragment>
        )
        },
    },
    {
      title: "Jefe Inmediato",
      dataIndex: ["jefeInmediato", "nombreCompleto"],
      width: "20%",
      align: "center",
      render: (text, fila) => {
        return (
          <React.Fragment>
            {fila.jefeInmediato?.nombreCompleto}
            <br />
            {fila.jefeInmediato?.fechaAprobacion!==undefined && fila.jefeInmediato?.fechaAprobacion!==null ? "Fecha Aprobación: "+ moment(fila.jefeInmediato?.fechaAprobacion).format("DD/MM/YYYY"):
             fila.jefeInmediato?.fechaRechazo!==undefined && fila.jefeInmediato?.fechaRechazo!==null && "Fecha Rechazo: "+ moment(fila.jefeInmediato?.fechaRechazo).format("DD/MM/YYYY")
            }
            <br />
            {fila.jefeInmediato?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado===EstadoSolicitudAusencia.PENDIENTE ? (
              <Tag color="warning">{fila.jefeInmediato.estadoAprobacion}</Tag>
            ): fila.jefeInmediato?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado=== "CANCELADO" ?(  
              <Tag color="purple">CANCELADO POR COLABORADOR</Tag>
            ) : fila.jefeInmediato?.estadoAprobacion === EstadoSolicitudAusencia.APROBADO ? (
              <Tag color="success">{fila.jefeInmediato?.estadoAprobacion}</Tag>
            ) : (
              <Tag color="error">{fila.jefeInmediato?.estadoAprobacion}</Tag>
            )}
          </React.Fragment>
        );
      },
    },
    {
      title: "Gestión Humana",
      width: "8%",
      align: "center",
      render: (fila) =>{
        return(
          <React.Fragment>
            {/* fila.estado === EstadoSolicitudAusencia.PENDIENTE ? (
          <Tag color="warning">{fila.estado}</Tag>
        ) : fila.estado === EstadoSolicitudAusencia.APROBADO ? (
          <Tag color="success">{fila.estado}</Tag>
        ) : (
          <Tag color="error">{fila.estado}</Tag>
        ), */}
            {fila.responsableGestionHumana?.fechaAprobacion!==undefined && fila.responsableGestionHumana?.fechaAprobacion!==null ? "Fecha Aprobación: "+ moment(fila.responsableGestionHumana?.fechaAprobacion).format("DD/MM/YYYY"):
            fila.responsableGestionHumana?.fechaRechazo!==undefined && fila.responsableGestionHumana?.fechaRechazo!==null && "Fecha Rechazo: "+ moment(fila.responsableGestionHumana?.fechaRechazo).format("DD/MM/YYYY")
          }
          <br />

          { fila.responsableGestionHumana?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado=== EstadoSolicitudAusencia.PENDIENTE? (
              <Tag color="warning">{fila.responsableGestionHumana.estadoAprobacion}</Tag>
            ):fila.responsableGestionHumana?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado=== "CANCELADO"? (
              <Tag color="purple">CANCELADO POR COLABORADOR</Tag>
            ) : fila.responsableGestionHumana?.estadoAprobacion === EstadoSolicitudAusencia.APROBADO ? (
              <Tag color="success">{fila.responsableGestionHumana.estadoAprobacion}</Tag>
            ) : (
              <Tag color="error">{fila.responsableGestionHumana?.estadoAprobacion}</Tag>
            )}
          </React.Fragment>
        )
      }

    },
    ...(isGlore ? [{
      title: "Aprobador de Primer Nivel",
      width: "20%",
      align: "center",
      render: (text, fila) => {
        return (
          <React.Fragment>
            {fila.responsableAprobacionPrimerNivel?.nombreCompleto}
            <br />
            {fila.responsableAprobacionPrimerNivel?.fechaAprobacion!==undefined && fila.responsableAprobacionPrimerNivel?.fechaAprobacion!==null ? "Fecha Aprobación: "+ moment(fila.responsableAprobacionPrimerNivel?.fechaAprobacion).format("DD/MM/YYYY"):
             fila.responsableAprobacionPrimerNivel?.fechaRechazo!==undefined && fila.responsableAprobacionPrimerNivel?.fechaRechazo!==null && "Fecha Rechazo: "+ moment(fila.responsableAprobacionPrimerNivel?.fechaRechazo).format("DD/MM/YYYY")
            }
            <br />
            {fila.responsableAprobacionPrimerNivel?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado===EstadoSolicitudAusencia.PENDIENTE ? (
              <Tag color="warning">{fila.responsableAprobacionPrimerNivel.estadoAprobacion}</Tag>
            ): fila.responsableAprobacionPrimerNivel?.estadoAprobacion === EstadoSolicitudAusencia.PENDIENTE && fila.estado=== "CANCELADO" ?(
              <Tag color="purple">CANCELADO POR COLABORADOR</Tag>
            ) : fila.responsableAprobacionPrimerNivel?.estadoAprobacion === EstadoSolicitudAusencia.APROBADO ? (
              <Tag color="success">{fila.responsableAprobacionPrimerNivel?.estadoAprobacion}</Tag>
            ) : (
              <Tag color="error">{fila.responsableAprobacionPrimerNivel?.estadoAprobacion}</Tag>
            )}
          </React.Fragment>
        );
      },
    }] : []),
  ]),
    {
      title: "Fecha Inicio",
      dataIndex: "fechaInicioAusencia",
      width: "10%",
      align: "center",
      render: (text, fila) => moment(fila.fechaInicioAusencia).format("DD/MM/YYYY hh:mm a"),
    },
    {
      title: "Fecha Fin",
      dataIndex: "fechaFin",
      width: "10%",
      align: "center",
      render: (text, fila) => moment(fila.fechaFinAusencia).format("DD/MM/YYYY hh:mm a"),
    },
    {
      title: "Dias",
      dataIndex: "diasSolicitados",
      width: "5%",
      align: "center",
    },
    {
      title: "Fecha de Solicitud",
      dataIndex: "fechaHoraSolicitud",
      width: "15%",
      align: "center",
      render: (text, fila) => moment(fila.fechaHoraSolicitud).format("DD/MM/YYYY hh:mm a"),
    },

    {
      title: "Acciones",
      align: "center",
      width: "15%",
      render: (text, fila) => <MenuAcciones solicitud={fila} />
    },
  ];

   // Columnas del detalle (para el Modal)
  const columnasDetalle = [
    { title: "Rol", dataIndex: "rol", align: "center" },
    { title: "Responsable", dataIndex: "responsable", align: "center" },
    { title: "Fecha", dataIndex: "fecha", align: "center" },
    { title: "Estado Aprobación", dataIndex: "estado", align: "center" },
  ];

  // Muestra quién aprobó/rechazó; si aún está pendiente, muestra los responsables asignados para hacerles seguimiento
  const obtenerNombreResponsable = (responsable, candidatos) => {
    if (responsable?.nombreCompleto) return responsable.nombreCompleto;
    if (candidatos?.length) return candidatos.map((c) => c.nombreCompleto).join(", ");
    return "-";
  };

  // 🔹 Función que genera las filas de detalle según la fila seleccionada
  const generarDatosDetalle = (fila) => {
    if (!fila) return [];
    const detalles = [];

    // Primer Nivel
    if (fila.permitirAprobacionPrimerFlujo) {
      detalles.push({
        key: "primerFlujo",
        rol: "Aprobación Primer Nivel",
        responsable: obtenerNombreResponsable(fila.responsableAprobacionPrimerNivel, fila.aprobadoresPrimerNivel),
        fecha:
          fila.responsableAprobacionPrimerNivel?.fechaAprobacion
            ? "Aprobación: " +
              moment(fila.responsableAprobacionPrimerNivel.fechaAprobacion).format("DD/MM/YYYY")
            : fila.responsableAprobacionPrimerNivel?.fechaRechazo
            ? "Rechazo: " +
              moment(fila.responsableAprobacionPrimerNivel.fechaRechazo).format("DD/MM/YYYY")
            : "-",
        estado: renderTagAprobacion(fila.responsableAprobacionPrimerNivel, fila),
      });
    }

    // Otro Primer Nivel
    if (fila.permitirOtroAprobacionPrimerFlujo) {
      detalles.push({
        key: "otroPrimerFlujo",
        rol: "Aprobación Primer Nivel",
        responsable: obtenerNombreResponsable(fila.responsableOtroAprobacionPrimerNivel, fila.otrosAprobadoresPrimerNivel),
        fecha:
          fila.responsableOtroAprobacionPrimerNivel?.fechaAprobacion
            ? "Aprobación: " +
              moment(fila.responsableOtroAprobacionPrimerNivel.fechaAprobacion).format("DD/MM/YYYY")
            : fila.responsableOtroAprobacionPrimerNivel?.fechaRechazo
            ? "Rechazo: " +
              moment(fila.responsableOtroAprobacionPrimerNivel.fechaRechazo).format("DD/MM/YYYY")
            : "-",
        estado: renderTagAprobacion(fila.responsableOtroAprobacionPrimerNivel, fila),
      });
    }

    // Segundo Nivel
    if (fila.permitirAprobacionSegundoFlujo) {
      detalles.push({
        key: "segundoFlujo",
        rol: "Aprobación Segundo Nivel",
        responsable: obtenerNombreResponsable(fila.responsableAprobacionSegundoNivel, fila.aprobadoresSegundoNivel),
        fecha:
          fila.responsableAprobacionSegundoNivel?.fechaAprobacion
            ? "Aprobación: " +
              moment(fila.responsableAprobacionSegundoNivel.fechaAprobacion).format("DD/MM/YYYY")
            : fila.responsableAprobacionSegundoNivel?.fechaRechazo
            ? "Rechazo: " +
              moment(fila.responsableAprobacionSegundoNivel.fechaRechazo).format("DD/MM/YYYY")
            : "-",
        estado: renderTagAprobacion(fila.responsableAprobacionSegundoNivel, fila),
      });
    }

    // Tercer Nivel (si existe)
    if (fila.permitirAprobacionTercerFlujo) {
      detalles.push({
        key: "tercerFlujo",
        rol: "Aprobación Tercer Nivel",
        responsable: obtenerNombreResponsable(fila.responsableAprobacionTercerNivel, fila.aprobadoresTercerNivel),
        fecha:
          fila.responsableAprobacionTercerNivel?.fechaAprobacion
            ? "Aprobación: " +
              moment(fila.responsableAprobacionTercerNivel.fechaAprobacion).format("DD/MM/YYYY")
            : fila.responsableAprobacionTercerNivel?.fechaRechazo
            ? "Rechazo: " +
              moment(fila.responsableAprobacionTercerNivel.fechaRechazo).format("DD/MM/YYYY")
            : "-",
        estado: renderTagAprobacion(fila.responsableAprobacionTercerNivel, fila),
      });
    }
    // Jefe Inmediato
    detalles.push({
      key: "jefe",
      rol: "Jefe Inmediato",
      responsable: fila.jefeInmediato?.nombreCompleto || "-",
      fecha:
        fila.jefeInmediato?.fechaAprobacion
          ? "Aprobación: " +
            moment(fila.jefeInmediato.fechaAprobacion).format("DD/MM/YYYY")
          : fila.jefeInmediato?.fechaRechazo
          ? "Rechazo: " +
            moment(fila.jefeInmediato.fechaRechazo).format("DD/MM/YYYY")
          : "-",
      estado: renderTagAprobacion(fila.jefeInmediato, fila),
    });

    // Otros Cargos
    detalles.push({
      key: "otros",
      rol: "Otros Cargos",
      responsable: fila.responsableOtrosCargos?.nombreCompleto || "-",
      fecha:
        fila.responsableOtrosCargos?.fechaAprobacion
          ? "Aprobación: " +
            moment(fila.responsableOtrosCargos.fechaAprobacion).format("DD/MM/YYYY")
          : fila.responsableOtrosCargos?.fechaRechazo
          ? "Rechazo: " +
            moment(fila.responsableOtrosCargos.fechaRechazo).format("DD/MM/YYYY")
          : "-",
      estado: renderTagAprobacion(fila.responsableOtrosCargos, fila),
    });

    // Gestión Humana
    detalles.push({
      key: "gestion",
      rol: "Gestión Humana",
      responsable: fila.responsableGestionHumana?.nombreCompleto || "-",
      fecha:
        fila.responsableGestionHumana?.fechaAprobacion
          ? "Aprobación: " +
            moment(fila.responsableGestionHumana.fechaAprobacion).format("DD/MM/YYYY")
          : fila.responsableGestionHumana?.fechaRechazo
          ? "Rechazo: " +
            moment(fila.responsableGestionHumana.fechaRechazo).format("DD/MM/YYYY")
          : "-",
      estado: renderTagAprobacion(fila.responsableGestionHumana, fila),
    });

    return detalles;
  };

  // Función auxiliar para mostrar el color y texto del estado
  const renderTagAprobacion = (aprobador, fila) => {
    const estado = aprobador?.estadoAprobacion;

    if (!estado) return <Tag color="default">-</Tag>;

    if (
      estado === EstadoSolicitudAusencia.PENDIENTE &&
      fila.estado === EstadoSolicitudAusencia.PENDIENTE
    )
      return <Tag color="warning">{estado}</Tag>;

    if (
      estado === EstadoSolicitudAusencia.PENDIENTE &&
      fila.estado === "CANCELADO"
    )
      return <Tag color="purple">CANCELADO POR COLABORADOR</Tag>;

    if (estado === EstadoSolicitudAusencia.APROBADO)
      return <Tag color="success">{estado}</Tag>;

    if (fila?.admin && fila?.estado === "CANCELADO")
      return <Tag color="purple">{fila.estado}</Tag>;

    return <Tag color="error">{estado}</Tag>;
  };

  const abrirDetalle = (fila) => {
    setFilaSeleccionada(fila);
    setVisible(true);
  };

  const cerrarDetalle = () => {
    setVisible(false);
    setFilaSeleccionada(null);
  };

  return (
    <React.Fragment>
      <>
        <Table
          rowKey={(value) => value.id}
          columns={columnas}
          dataSource={solicitudesAusencia}
          pagination={{
            pageSize: tamanioPaginado,
            total: totalRegistros,
            current: paginaActual,
            showTotal: (total) => `Total ${total} registros`,
            onChange: (page, pageSize) => onCambiarPaginacion(page, pageSize),
          }}
          expandable={{
            expandedRowRender: (fila) => <Comentario registro={fila} />,
            rowExpandable: (fila) =>
              ((isMaccaferriConstruction || isMaccaferriDePeru) &&
                fila.comentario !== null &&
                fila.comentario !== undefined &&
                fila.comentario !== "") ||
              (isAceros && fila.informacionAdicional !== null)
              || (isSDF)
              || (isSDFEnergia),
          }}
        />
        <Modal
          open={visible}
          title="Detalle de Aprobación"
          onCancel={cerrarDetalle}
          footer={null}
          width={750}
        >
          <Table
            columns={columnasDetalle}
            dataSource={generarDatosDetalle(filaSeleccionada)}
            pagination={false}
            size="small"
          />
        </Modal>
      </>
      <ModalSeguimiento />
      <ModalAdjuntarAltaMedica />
      <ModalCancelarSolicitud />
    </React.Fragment>
  );
};
const Comentario = ({ registro }) => {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const isMaccaferriDePeru = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20418710757" ? true : false;
	const isMaccaferriConstruction = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20521749378" ? true : false;
	const isAceros = getUsuarioAutenticado().empresaSeleccionada?.ruc==="20538379302"	? true	: false;
  const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
  const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

	return (
		<React.Fragment>
			{(isMaccaferriDePeru || isMaccaferriConstruction) && (
				<p style={{ margin: 5 }}>{"EMPLEADO DESIGNADO: " + registro.comentario}</p>
			)}
			{isAceros && registro.informacionAdicional && (
				<div style={{ marginLeft: 50 }}>
					{/* Itera sobre las propiedades del objeto informacionAdicional */}
					{Object.entries(registro.informacionAdicional).map(([key, value], index) => (
					<p key={index}>
							<strong>{key.replace(/([A-Z])/g, ' $1').toUpperCase()}: </strong>
						{typeof value === 'string' && value.includes("T") // Comprueba si es una fecha en formato ISO
						? moment(value).format("DD/MM/YYYY")
						: value}
					</p>
					))
					}
					<p>
						<strong>Comentario: </strong> {registro.comentario}
					</p>
				</div>
			)}
      {(isSDF || isSDFEnergia) && (
				<>
					{registro.informacionAdicional ? (
            <div style={{ marginLeft: 50 }}>
							{Object.entries(registro.informacionAdicional).map(([key, value], index) => {
								// Reemplazar nombres de keys
								let displayKey = key;
								if (key === 'En-El-Turno-1') {
									displayKey = 'EN- EL- TURNO-SOLICITADO';
								} else if (key === 'En-El-Turno-2') {
									displayKey = 'EN- EL- TURNO-ORIGINAL';
								}
								
								return (
									<p key={index}>
										<strong>{displayKey.replace(/([A-Z])/g, " $1").toUpperCase()}: </strong>
										{typeof value === "boolean"
											? value ? "Sí" : "No"
											: Array.isArray(value)
											? value.map(function(item, i) {
												return (
													<span key={i} style={{ display: "block" }}>
														{typeof item === "object" && item !== null
															? Object.entries(item).map(function(e) { var k=e[0],v=e[1]; return k + ": " + (typeof v === "string" && v.match(/^\d{4}-\d{2}-\d{2}T/) && moment(v).isValid() ? moment(v).format("DD/MM/YYYY") : v); }).join(" | ")
															: String(item)}
													</span>
												);
											})
											: typeof value === "object" && value !== null
											? JSON.stringify(value)
											: typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T/) && moment(value).isValid()
											? moment(value).format("DD/MM/YYYY")
											: value}
									</p>
								);
							})}
							<p>
								<strong>Comentario: </strong> {registro.comentario}
							</p>
						</div>
					) : (
						<p>
							<strong>Comentario: </strong> {registro.comentario}
						</p>
					)}
				</>
			)}
		</React.Fragment>
	);
};
export default ListaConsultaSolicitudes;
